import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/educator_handbook/page.js");
